import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IRecruiters {
  id?: number;
  page_id?: number;
  component_id?: number;
  title?: string;
  title_text_color?: string;
  desktop_bg_image?: string;
  mobile_bg_image?: string;
  alt_image?: string;
  status?: boolean;
  variant?: string;
}

export async function createRecruiters(payload: Partial<IRecruiters>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.RECRUITERS.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateRecruiters(id: number, payload: Partial<IRecruiters>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.RECRUITERS.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}